const pathConstants = {
  PRO_RESOURCE_PREFIX: '/workspace/student/'
}

export default pathConstants
